import React from "react"

const LinkButton = props => {
    
    const {onClick, text} = props;

    const handleOnClick = (e) => {
        e.preventDefault();
        if (onClick && (typeof onClick === "function")) onClick();
    }

    return (<>
        <a href="#" onClick={handleOnClick}>{text}</a>
    </>)
}

export default LinkButton;